const workbench = () => import('@/views/main/analysis/workbench/workbench.vue')
export default {
  path: '/main/analysis/workbench',
  name: 'workbench',
  component: workbench,
  children: []
}
